// הקטנה + דחיסה של תמונה בדפדפן לפני העלאה (canvas) - השרת לא מקטין
// תמונות בעצמו, ותמונה ישר מהמצלמה הייתה מאטה את האפליקציה לכל המשתמשים.
// אותן מידות כמו באפליקציה (client/app/services/ImageUpload.ts): לוגו 800
// כ-PNG (שומר על שקיפות), גלריה 1600 כ-JPEG. תמונה קטנה מהמקסימום לא מוגדלת
const SPECS = {
  logo: { maxSide: 800, type: 'image/png', quality: undefined },
  gallery: { maxSide: 1600, type: 'image/jpeg', quality: 0.75 },
};

export const IMAGE_HINTS = {
  logo: 'מומלץ: ריבוע 800×800, PNG עם רקע שקוף או לבן. מוקטן אוטומטית',
  gallery: 'מומלץ: תמונות לרוחב 1600×1000, איכותיות ומוארות, עם העיקר במרכז. מוקטנות ונדחסות אוטומטית',
};

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
  img.src = url;
});

export async function shrinkImageFile(file, kind) {
  const spec = SPECS[kind];
  // SVG/GIF - משאירים כמו שהם (וקטורי/מונפש)
  if (!spec || !file?.type?.startsWith('image/') || file.type === 'image/svg+xml' || file.type === 'image/gif') return file;
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, spec.maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    const width = Math.round(img.naturalWidth * scale);
    const height = Math.round(img.naturalHeight * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (spec.type === 'image/jpeg') {
      // JPEG בלי שקיפות - רקע לבן במקום שחור
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(img, 0, 0, width, height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, spec.type, spec.quality));
    // אם משום מה יצא גדול יותר מהמקור (תמונה קטנה ודחוסה מראש) - שולחים את המקור
    return blob && blob.size < file.size ? blob : file;
  } catch {
    return file;
  }
}
